import { Component, OnInit } from '@angular/core';
import { MODAL, ModalService } from '../../services/modal.service';
import { environment } from 'src/environments/environment';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'ng-hbm-bdi-store-stock',
  templateUrl: './store-stock.component.html'
})
export class StoreStockComponent implements OnInit {

  public storeStock: any;
  public ean: string;

  constructor(public modalService: ModalService, private gtm: GTM, private user: UserService) {
    this.storeStock = modalService.currentDatas.storeStock.filter(s => s.storeId !== environment.bdi.distributionCenterStoreId);
    this.storeStock.sort((a, b) => {
      const storeNameA = a.storeName.toLowerCase(); // Convertir en minuscules pour un tri insensible à la casse
      const storeNameB = b.storeName.toLowerCase();

      if (storeNameA < storeNameB) {
        return -1; // a vient avant b
      }
      if (storeNameA > storeNameB) {
        return 1; // b vient avant a
      }
      return 0; // Les storeId sont égaux
    });
    this.ean = modalService.currentDatas.ean;
  }

  ngOnInit(): void {
    this.gtm.trackEvent('click', 'store-stock-' + this.user.context.toLowerCase(), 'open', {'project_amount': this.modalService.currentDatas.beautifiedBom.totalPrice.toFixed(2)});
  }

  returnToProductList() {
    this.gtm.trackEvent('click', 'store-stock-' + this.user.context.toLowerCase(), 'close', {'project_amount': this.modalService.currentDatas.beautifiedBom.totalPrice.toFixed(2)});
    this.modalService.display(
      MODAL.PRODUCTS_LIST,
      {
        bom: this.modalService.currentDatas.beautifiedBom,
        flattenBom: this.modalService.currentDatas.flattenBom
      });
  }
}
